/* NURIALE MODERN — scroll reveals (June 2026).
   Companion to nuriale-modern.css. Adds staggered fade-up reveals to
   sections the theme's native reveal-on-scroll system doesn't cover.
   Bails out entirely for reduced-motion users and old browsers, and never
   hides elements that are already in the viewport (no flash). */
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  document.documentElement.classList.add('nur-js');

  function init() {
    var staggered = [
      '.shopify-section--subcategory-pills .subcat-pill',
      '.shopify-section--text-with-icons .text-with-icons__item',
      '.shopify-section--newsletter .content.section-stack > *',
      '.product-gallery__media',
      '.her-lineup__row'
    ];
    var singles = [
      '.shopify-section--subcategory-pills .section-header',
      '.shopify-section--featured-collections .section-header',
      '.shopify-section--apps [data-oke-carousel]'
    ];

    var targets = [];

    staggered.forEach(function (sel) {
      var counts = {};
      document.querySelectorAll(sel).forEach(function (el) {
        if (el.closest('[reveal-on-scroll]')) return;
        var sec = el.closest('.shopify-section');
        var key = (sec && sec.id) || 'page';
        counts[key] = counts[key] || 0;
        el.style.setProperty('--nur-i', Math.min(counts[key]++, 5));
        targets.push(el);
      });
    });

    singles.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        if (el.closest('[reveal-on-scroll]')) return;
        targets.push(el);
      });
    });

    if (!targets.length) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('nur-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -8% 0px' });

    targets.forEach(function (el) {
      var r = el.getBoundingClientRect();
      // Already on screen at load: leave it visible rather than animating.
      if (r.top < window.innerHeight * 0.9 && r.bottom > 0) return;
      el.setAttribute('data-nur-reveal', '');
      io.observe(el);
    });
  }

  /* ------------------------------------------------------------------
     THE QUIET REEL — cinematic behaviors (June 2026).
     Companion to nuriale-modern.css sections 10-17. Everything here is
     behind the same reduced-motion / IntersectionObserver bail-outs.
     ------------------------------------------------------------------ */
  function initCinematic() {
    // 12. SCENE CHANGE — frosted header once scrolled past the hero.
    var tracker = document.getElementById('header-scroll-tracker');
    if (tracker) {
      new IntersectionObserver(function (entries) {
        document.documentElement.classList.toggle('nur-scrolled', !entries[0].isIntersecting);
      }).observe(tracker);
    }

    // 13. LIGHT PASS — one champagne sweep over editorial stills on reveal.
    var lits = document.querySelectorAll('.shopify-section--image-with-text .image-with-text > picture');
    if (lits.length) {
      var lio = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('nur-lit');
            lio.unobserve(entry.target);
          }
        });
      }, { threshold: 0.35 });
      lits.forEach(function (el) { lio.observe(el); });
    }

    // 11. GOLD THREAD RECEIPT — free-shipping progress + subtotal tick +
    //     one checkout sheen per drawer open. FreeShippingBar normalizes
    //     both its threshold and total-price attributes to cents.
    function updateReceipt() {
      document.querySelectorAll('free-shipping-bar.free-shipping-bar').forEach(function (el) {
        var threshold = parseFloat(el.getAttribute('threshold'));
        var total = parseFloat(el.getAttribute('total-price'));
        if (!isFinite(threshold) || threshold <= 0 || !isFinite(total)) return;
        var p = Math.min(total / threshold, 1);
        el.style.setProperty('--nur-progress', p);
        if (p >= 1) {
          el.classList.add('nur-unlocked');
        } else {
          el.classList.remove('nur-unlocked');
        }
      });
    }

    document.addEventListener('cart:change', function () {
      requestAnimationFrame(updateReceipt);
    });

    document.addEventListener('cart-drawer:refreshed', function () {
      requestAnimationFrame(updateReceipt);
      var subtotal = document.querySelector('.cart-drawer__subtotal');
      if (subtotal) {
        subtotal.classList.add('nur-tick');
        setTimeout(function () { subtotal.classList.remove('nur-tick'); }, 500);
      }
    });

    document.addEventListener('dialog:after-show', function (event) {
      if (!event.target || !event.target.classList || !event.target.classList.contains('cart-drawer')) return;
      updateReceipt();
      var checkout = event.target.querySelector('.cart-drawer__footer .button[type="submit"]');
      if (checkout && !checkout.classList.contains('nur-just-opened')) {
        checkout.classList.add('nur-just-opened');
        checkout.addEventListener('animationend', function handler() {
          checkout.classList.remove('nur-just-opened');
          checkout.removeEventListener('animationend', handler);
        });
      }
    });

    updateReceipt();
  }

  function boot() {
    init();
    initCinematic();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
